import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "../OrigamiAds";
import { ProcessedOrigamiAdsByGroupRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "CLUSTER",
    dataIndex: "cluster",
  },
  {
    title: "LWTD",
    dataIndex: "lwtd",
  },
  {
    title: "WTD",
    dataIndex: "wtd",
  },
  {
    title: "WTD DIFF",
    dataIndex: "wtd_diff",
  },
  {
    title: "WTD PERC DIFF",
    dataIndex: "wtd_perc_diff",
  },
  {
    title: "LMTD",
    dataIndex: "lmtd",
  },
  {
    title: "MTD",
    dataIndex: "mtd",
  },
  {
    title: "MTD DIFF",
    dataIndex: "mtd_diff",
  },
  {
    title: "MTD PERC DIFF",
    dataIndex: "mtd_perc_diff",
  },
  {
    title: "LQTD",
    dataIndex: "lqtd",
  },
  {
    title: "QTD",
    dataIndex: "qtd",
  },
  {
    title: "QTD DIFF",
    dataIndex: "qtd_diff",
  },
  {
    title: "QTD PERC DIFF",
    dataIndex: "qtd_perc_diff",
  },
];

type ProcessedOrigamiAdsByGroupTableProps = {
  loading: boolean;
  records: Array<ProcessedOrigamiAdsByGroupRecord>;
};

const ProcessedOrigamiAdsByGroupTable = ({ loading, records }: ProcessedOrigamiAdsByGroupTableProps): ReactElement => {

  return (
    <Table
      className="processed-origami-ads-table"
      dataSource={records}
      columns={columns}
      loading={loading}
      rowKey="cluster"
      pagination={false}
      scroll={{ y: 250 }}
      size="small"
      rowClassName={rowClassName}
    />
  );
};

export default ProcessedOrigamiAdsByGroupTable;
